import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    GetClientListNetwork,
    getMonthsYearsAction,
    getProviderBasedOnChains,
    getProviderChains,
} from "../../../redux/actions/GlobalAction";
import Datetime from "react-datetime";
import Select from "react-select";
import { getAllProviderListNetworkAction } from "../../../redux/actions/TestPackageNetworkAction";
import { placeholderSelectColor } from "../NetworkIntelligence/UsageCoverage/helper";
import { InputOptionSelect } from "../../../common/InputOptionSelect";
import { funnelCard, initSendToQc, initialFilterState, initialFilterStateForInvoiceGeneration } from "./helper";
import {
    AddPayoutApprovalAction,
    GeneratePayoutAction,
    GetAppointmentPayoutDetailsNetworkAction,
    GetInvoiceDetailsNetwork,
    GetPayoutStatus,
    PayoutInvoiceGenerationBulkUpload,
    getPayoutCountsNetworkAction,
    getPayoutDetailsNetworkAction,
    getProviderPayoutDetailsNetworkAction,
} from "../../../redux/actions/PayoutAction";
import Modal from "react-modal";
import { TotalPayout } from "./TotalPayout";
import { SearchIcon } from "../../../Utils/SvgIcons";
import "../../../assets/css/payout.css";
import { TotalProvider } from "./TotalProvider";
import { TotalAppointments } from "./TotalAppointments";
import { UnsuccessfulAppointment } from "./UnsuccessfulAppointment";
import { PayoutSentToQc } from "./PayoutSentToQc";
import { getSnackbarSuccess, isLoadingAction, reverseString } from "../../../Utils/helper";
import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import { getMenus, getNetworkMenuId, getToken, validateProviderPayout } from "../../../Utils/types";
import { AdditionalApptHeader } from "./AdditionalApptHeader";
import { AdvancePayout } from "./AdvancePayout";
import { isValidDate } from "../../ServicePortal/ProfileDetail/helper";
import { clearCurrentPage } from "../ProviderProfileDetails/helper";
import { PayoutExportToExcel } from "./PayoutExportToExcel";
import { BulkRateUpload } from "./BulkRateUpload";
import { SendToQcBulkUpload } from "./SendToQcBulkUpload";
import { StatusQueFunnel } from "../../InsurerBilling/helper";
import CustomPagination from "../../../common/CustomPagination";
import moment from "moment";
import AdditionalComponentHeader from "../../helperComponent/AdditionalComponentHeader";


export const InvoiceGeneration = ({ setadpTab }) => {
    const [providerValues, setProviderValues] = useState(null);
    const [switchTab, setSwitchTab] = useState("totalPayouts");
    const [client, setClient] = useState(null);
    const [searchFilter, setSearchFilter] = useState(initialFilterStateForInvoiceGeneration);
    const formRef = useRef();
    const [sendToQcPayload, setSendToQcPayload] = useState(initSendToQc);
    const [header, setHeader] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectAllFlag, setSelectAllFlag] = useState(false);
    const [isOpenAdvance, setIsOpenAdvance] = useState(false);
    const [isOpenSetting, setIsOpenSetting] = useState(false);
    const [isExportToExcel, setIsExporToExcel] = useState(false);
    const [isLoadingExcel, setIsLoadingExcel] = useState(false);
    const [bulkSendToQC, setBulkSendToQC] = useState(false)
    const [inputClient, setInputClient] = useState("");
    const [providerDetail, setProviderDetail] = useState([]);
    const [month, setMonth] = useState(null);
    const [showData, setShowData] = useState(false);
    const [bulkRate, setBulkRate] = useState(false)
    const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
    const payoutReducer = useSelector((state) => state?.PayoutReducer);
    const globalReducer = useSelector((state) => state?.globalReducer);
    const [header2, setHeader2] = useState([
        // { label: "BuType", col: "buType" },
        { label: "Provider Name", col: "providerName", show: true, default: true, index: 0 },
        { label: "Chain Name", col: "chainName", show: true, default: true, index: 1 },
        { label: "Case No", col: "caseNo", show: true, default: true, index: 2 },
        { label: "Policy Ref No", col: "policyRefNo", show: true, default: true, index: 3 },
        { label: "Invoice No", col: "invoiceNo", show: true, default: true, index: 4 },
        { label: "Invoice Amount", col: "invoiceAmount", show: true, default: true, index: 5 },
        { label: "Invoice Date", col: "invoiceDate", show: true, default: true, index: 6 },
        { label: "Proposer Name", col: "proposerName", show: false, default: false, index: 7 },
        // { label: "ChainId", col: "chainId" },
        { label: "Month", col: "month", show: false, default: false, index: 8 },
        // { label: "ProviderId", col: "providerId" },
        { label: "Year", col: "year", show: false, default: false, index: 9 },
    ]);
    const getHeaders = () => {
        if (searchFilter?.buType === "CBU") {
            return header2?.length > 0 ? header2?.filter((ele) => ele?.label !== "Policy Ref No") : []
        }
        return header2
    }
    const dispatch = useDispatch();

    const changeHandler = (name, value) => {
        setSearchFilter({ ...searchFilter, [name]: value });
    };

    useEffect(() => {
        dispatch(GetPayoutStatus(false, true))
        dispatch(
            GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "CBU" })
        );
        dispatch(getMonthsYearsAction());
        dispatch(getProviderChains());
    }, []);


    useEffect(() => {
        if (searchFilter?.chainId === 0 || !searchFilter?.chainId) return;
        dispatch(getProviderBasedOnChains(searchFilter?.chainId));
    }, [searchFilter?.chainId])





    useEffect(() => {
        dispatch(GetInvoiceDetailsNetwork(searchFilter))
    }, [])

    useEffect(() => {
        console.log("payoutReducer", payoutReducer)
    }, [payoutReducer])


    const handleSearch = () => {
        searchFilter.page = 1;
        dispatch(GetInvoiceDetailsNetwork(searchFilter))

        setProviderDetail([]);
    };

    const handleSorting = async (type) => {
        changeHandler("SortDirection", type);
        dispatch(GetInvoiceDetailsNetwork({
            ...searchFilter,
            SortDirection: type
        }))

    };

    const downloadFile = (ele) => {
        isLoadingAction(true, dispatch);
        setIsLoadingExcel(true);
        let recId = providerDetail.map((ele) => {
            return ele?.receiveId;
        });
        let clId = providerDetail.map((ele) => {
            return { clientId: ele?.clientId };
        });
        const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelInvoiceDetailsNetwork`;
        let data = {
            ...searchFilter,
            isExportToExcel: true,
            AppointmentIds: selectAll ? "" : providerDetail.map((ele) => ele?.appointmentId).toString()
            // clients:clId,

        };

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: getToken(),
                MenuId: getNetworkMenuId()?.menuId,
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.blob())
            .then((blob) => {
                isLoadingAction(false, dispatch);
                const filename = "InsurerReceiptDetails.xlsx";
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsLoadingExcel(false);
                setProviderDetail([])

            })
            .catch((error) => {
                console.error("Failed to fetch the file");
                setIsLoadingExcel(false);
            });
    };

    const handleClear = () => {
        setProviderDetail([]);
        setProviderValues(null);
        setInputClient("");
        formRef.current.reset();
        setMonth(new Date().getMonth + 1);

        setSearchFilter(initialFilterStateForInvoiceGeneration)
        dispatch(GetInvoiceDetailsNetwork(initialFilterStateForInvoiceGeneration))


    };

    const handleSaveChanges = async (e) => {
        e.preventDefault();
        isLoadingAction(true, dispatch);
        setIsLoadingExcel(true);
        if (searchFilter?.uploadFile) {
            const formData = new FormData();
            formData.append("file", searchFilter?.uploadFile);
            // const res = await dispatch(PayoutInvoiceGenerationBulkUpload(formData, searchFilter));
            // console.log("res123", res);
            //&InvoiceAmount=${searchFilter?.invoiceAmount}
            isLoadingAction(true, dispatch);
            let url = `${API_URL_WITHOUT_USER}/NetworkPayout/PayoutInvoiceGenerationBulkUpload?month=${searchFilter?.month}&year=${searchFilter?.year}&ChainId=${searchFilter?.chainId}&ProviderId=${searchFilter?.providerId}&InvoiceNo=${searchFilter?.invoiceNo}&InvoiceDate=${searchFilter?.invoiceDate}`;
            fetch(url, {
                method: "POST",
                headers: {
                    Authorization: getToken(),
                    MenuId: getNetworkMenuId()?.menuId,
                },
                body: formData,
            })
                .then((response) => response.blob())
                .then((blob) => {
                    let filename = "InvoiceGeneration.xlsx";
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    isLoadingAction(false, dispatch);
                    dispatch(GetInvoiceDetailsNetwork(initialFilterStateForInvoiceGeneration))
                    setSearchFilter(initialFilterStateForInvoiceGeneration);
                })
                .catch((error) => {
                    console.error("Failed to fetch the file");
                    isLoadingAction(false, dispatch);
                });
            isLoadingAction(false, dispatch);


        } else {
            getSnackbarSuccess('error', 'Please Upload File to proceed further.', dispatch)
            isLoadingAction(false, dispatch);
            setIsLoadingExcel(false);

        }

    }

    return (
        <div className="right-section pt-1 pt-3" style={{ padding: "10px" }}>
            <div className="card staff-details-section">
                <div className="card-body">
                    <h4 className="pt-2">Invoice Generation</h4>
                   

                    <form ref={formRef} onSubmit={handleSaveChanges}>
                    <div className="row">
                        <div className="col-lg-2 col-md-2 col-sm-3 mt-3">
                            <Datetime
                                dateFormat="YYYY"
                                timeFormat={false}
                                className="page-content payoutYearFilter"
                                isValidDate={isValidDate}
                                value={searchFilter?.year}
                                placeholder="Select Year"
                                closeOnSelect={true}
                                onChange={(e) =>
                                    setSearchFilter({
                                        ...searchFilter,
                                        year: e?.format("YYYY"),
                                    })
                                }
                            />
                        </div>

                        <div className="col-lg-2 col-md-2 col-sm-3  mt-3">
                            <select
                                name="BusinessType"
                                className="white-form-select "
                                style={{ height: "60px" }}
                                value={searchFilter?.month ? searchFilter?.month : ""}
                                onChange={(e) => {
                                    setMonth(e.target.value);
                                    setSearchFilter({
                                        ...searchFilter,
                                        month: e.target.value ? e.target.value : null,
                                    });
                                }}
                                required
                            >

                                <option value=""> Select Month</option>
                                {globalReducer?.getMonthYear?.lstMonths?.map((ele) => {
                                    return (
                                        <option value={+ele?.monthId}>{ele?.monthName}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12  mt-3">
                            <select
                                name="BusinessType"
                                style={{ height: "60px" }}
                                className="white-form-select "
                                value={searchFilter?.chainId ? searchFilter?.chainId : ""}
                                onChange={(e) => {
                                    setSearchFilter({
                                        ...searchFilter,
                                        chainId: e.target.value,
                                    })
                                }}
                                required
                            >
                                <option value={0}>Select Provider Chain</option>
                                {globalReducer?.getProviderChains?.lstChain?.map((ele) => {
                                    return (
                                        <option value={+ele?.chainId}>{ele?.chainName}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12 mt-3">
                            <select
                                name="BusinessType"
                                style={{ height: "60px" }}
                                className="white-form-select "
                                value={searchFilter?.providerId ? searchFilter?.providerId : ""}
                                onChange={(e) => {
                                    setSearchFilter({
                                        ...searchFilter,
                                        providerId: e.target.value,
                                    })
                                }}

                            >
                                <option value={0}>Select Provider</option>
                                {globalReducer?.getProviderBaseOnChains?.lstProviders?.map((ele) => {
                                    return (
                                        <option value={+ele?.providerId}>{ele?.providerName}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                            <input
                                type="text"
                                value={searchFilter?.invoiceNo ? searchFilter?.invoiceNo : ""}
                                className="white-form-select "
                                placeholder="Invoice Number"
                                style={{ paddingBottom: "25px", paddingTop: "25px" }}
                                onChange={(e) => {
                                    setSearchFilter({
                                        ...searchFilter,
                                        invoiceNo: e.target.value.trimStart()
                                    })
                                }}
                                required
                            />
                        </div>
                        {/* <div className="col-lg-3 col-md-6 col-sm-12 mt-3">
                            <input
                                type="number"
                                value={searchFilter?.invoiceAmount ? searchFilter?.invoiceAmount : ""}
                                className="white-form-select "
                                placeholder="Invoice Amount"
                                style={{ paddingBottom: "25px", paddingTop: "25px" }}
                                onChange={(e) => {
                                    setSearchFilter({
                                        ...searchFilter,
                                        invoiceAmount: e.target.value.trimStart()
                                    })
                                }}
                                required
                            />
                        </div> */}
                        <div className="col-lg-3 col-md-6 col-sm-12 mt-3">
                            <input
                                type="date"
                                value={searchFilter?.invoiceDate ? searchFilter?.invoiceDate : ""}
                                className="white-form-select "
                                placeholder="Invoice Date"
                                style={{ paddingBottom: "25px", paddingTop: "25px" }}
                                data-date-format="DD MMMM YYYY"
                                onChange={(e) => {
                                    setSearchFilter({
                                        ...searchFilter,
                                        invoiceDate: e.target.value
                                    })
                                }}
                                required
                            />
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12 mt-3"> 
                            <div className="">

                                {!searchFilter?.uploadFile &&
                                    <div class="file-inputt"  >
                                        <label htmlFor={"welcome"} style={{ padding: "15px" }}>
                                            <span style={{ marginRight: "14px", fontSize: "14px" }}>
                                                Choose XLSX File To Upload
                                            </span>
                                            <span style={{ marginLeft: "14px", color: "#3498db", fontSize: "14px" }}>
                                                <i class="fa-solid fa-cloud-arrow-up"></i>
                                            </span>
                                        </label>
                                        <input
                                            id="welcome"
                                            // accept=".html"
                                            type="file"
                                            onChange={(e) => {
                                                setSearchFilter({
                                                    ...searchFilter,
                                                    uploadFile: e.target.files[0]
                                                })
                                            }}
                                        />
                                    </div>}

                                {searchFilter?.uploadFile && <div className="">
                                    <div><p>{searchFilter?.uploadFile?.name}</p></div>
                                    <div onClick={() => {
                                        setSearchFilter({
                                            ...searchFilter,
                                            uploadFile: null
                                        })
                                    }}  ><p style={{ color: "red", cursor: "pointer" }} >{"Remove"}</p></div>
                                </div>}

                            </div>
                        </div>




                    </div>

                        <div className="mt-3 d-flex flex-wrap gap-3">
                            <button
                                className="search"

                                style={{ border: "none" }}
                                type="button"

                            >
                                <a className="sidebar-links" href={
                                    `${API_URL_WITHOUT_USER}/FileManager/DownloadFile?path=ProvidersSampleFiles/Bulk%20Invoice%20Generation%20Sample.xlsx`
                                }>
                                    <span className="sidebar-link-text">Click Here to Download Sample File</span>
                                </a>
                            </button>
                            <button
                                className="search"

                                style={{ border: "none" }}
                                type="submit"
                            >
                                <a className="sidebar-links">
                                    <span className="sidebar-link-text">Submit</span>
                                </a>
                            </button>

                        </div>

                    </form>

                    {/* IBU/CBU WALA */}


                    <br />


                    {/* filter start */}
                    

                    <div className="row-results ">
                        <div className="me-5 d-flex gap-1">
                            <select
                                className="row-selectdropdown"
                                value={searchFilter?.rows}
                                onChange={(e) => {
                                    setSearchFilter({
                                        ...searchFilter,
                                        page: 1,
                                        rows: e.target.value,
                                    });
                                    dispatch(
                                        GetInvoiceDetailsNetwork({
                                            ...searchFilter,
                                            rows: e.target.value,
                                            page: 1,
                                        })
                                    );
                                    // handleDataCount(e);
                                }}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            <p className="results">
                                Total <span>{globalReducer?.getTotalCount}</span> results
                            </p>
                        </div>
                        <div className="d-flex gap-1">

                            <div className="">
                                <select
                                    name="BusinessType"

                                    style={{ padding: "6px", marginTop: "2px" }}
                                    value={searchFilter?.buType}

                                    onChange={(e) => {
                                        setSearchFilter({
                                            ...searchFilter,
                                            buType: e.target.value
                                        })
                                        searchFilter.page = 1;
                                        dispatch(GetInvoiceDetailsNetwork({
                                            ...searchFilter,
                                            buType: e.target.value
                                        }))
                                    }}
                                >
                                    <option value="IBU">IBU</option>
                                    <option value="CBU">CBU</option>
                                </select>
                            </div>
                            <div className="payputMultiSelect">
                                <input
                                    type="text"
                                    value={searchFilter?.caseNo ? searchFilter?.caseNo : ""}
                                    className="white-form-select "
                                    placeholder="Case No. / Policy Ref No."
                                    style={{ paddingBottom: "15px", paddingTop: "15px",width:"180px" }}
                                    onChange={(e) => {
                                        setSearchFilter({
                                            ...searchFilter,
                                            caseNo: e.target.value
                                        })
                                    }}
                                    required
                                />
                            </div>


                            <button
                                className="search"
                                type="button"
                                style={{ border: "none" }}
                                onClick={handleSearch}
                            >
                                <a className="sidebar-links">
                                    <SearchIcon />
                                    <span className="sidebar-link-text">Search</span>
                                </a>
                            </button>
                            <button
                                className="search"
                                type="button"
                                style={{ border: "none" }}
                                onClick={() => handleClear("CBU")}
                            >
                                <a className="sidebar-links">
                                    <span className="sidebar-link-text">Clear All</span>
                                </a>
                            </button>
                            <button
                                className="btn search__btn"
                                type="button"
                                style={{ border: "none" }}
                                disabled={providerDetail?.length < 2}
                                // style={{ minWidth: "inherit" }}
                                onClick={downloadFile}
                            >
                                <i className="fa-solid fa-arrow-down"></i> &nbsp; Export To
                                Excel
                            </button>

                            <button
                                className="dropdown-toggle appointment-dropdown search"
                                style={{ width: "-110px" }}
                                type="button"
                                id="ascDescPayableBtn"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <span className="sidebar-link-text">
                                    {searchFilter?.SortDirection === "asc"
                                        ? "ASC"
                                        : "DESC"}
                                </span>
                                <span className="sidebar-link-text">
                                    <i className="fa fa-list"></i>
                                </span>
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="ascDescPayableBtn">
                                <li>
                                    <button
                                        className="dropdown-item btn-border-bottom"
                                        type="button"
                                        onClick={() => handleSorting("asc")}
                                    >
                                        Ascending Order
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() => handleSorting("desc")}
                                    >
                                        Descending Order
                                    </button>
                                </li>
                            </ul>
                            <button
                                className="search__btn ascDescBtn p-2"
                                id="ascDescPayableBtn"
                                onClick={() => setIsOpenSetting(true)}
                                type="button"
                            >
                                &nbsp;
                                <i class="fa-solid fa-gear" style={{ fontSize: "20px" }}></i>
                            </button>
                        </div>
                    </div>

                    <div className="select_all_div m-2">
                        {(providerDetail?.length > 0) && (
                            <>
                                {!selectAll && (
                                    <>
                                        <p>{providerDetail?.length} Cases are selected</p>
                                        {globalReducer?.getTotalCount > searchFilter.rows && (
                                            <>
                                                {selectAllFlag === true && (
                                                    <span
                                                        className="select_all_primary_cases"
                                                        onClick={() => setSelectAll(true)}
                                                    >
                                                        Select all {globalReducer?.getTotalCount}{" "}
                                                        Cases
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                                {selectAll && (
                                    <p>
                                        {globalReducer?.getTotalCount} Cases are selected
                                    </p>
                                )}
                            </>
                        )}
                    </div>



                    <div className="table-responsive __custom__properties">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={
                                                payoutReducer?.getTotalAppointmentPayout?.length ===
                                                providerDetail?.length
                                            }
                                            onClick={(e) => {
                                                setSelectAllFlag(true);
                                                setSelectAll(false)
                                                e.target.checked
                                                    ? setProviderDetail(payoutReducer?.getTotalAppointmentPayout)
                                                    : setProviderDetail([])
                                            }
                                            }
                                            readOnly
                                        />
                                    </th>

                                    {getHeaders()?.filter((ele) => ele?.show === true)?.map((ele) => {
                                        return (
                                            <th
                                                style={{ textAlign: "start" }}
                                            //className="addHeader"
                                            // style={{ textAlign: (ele?.label === "ProviderName" || ele?.label === "BuType" || ele?.label==="ChainName") ? "" : "center" }}
                                            >
                                                {ele?.label}
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            {payoutReducer?.getTotalAppointmentPayout?.length !== 0 && (
                                <tbody>
                                    {payoutReducer?.getTotalAppointmentPayout?.map((ele, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    {" "}
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        style={{ textAlign: "center" }}
                                                        checked={providerDetail?.some(
                                                            (item) => ele === item
                                                        )}
                                                        onClick={(e) => {
                                                            if (e.target.checked) {
                                                                setProviderDetail([...providerDetail, ele]);
                                                            } else {
                                                                setProviderDetail(
                                                                    providerDetail?.filter((item) => ele !== item)
                                                                );
                                                            }
                                                        }}
                                                        readOnly
                                                    />
                                                </td>


                                                {getHeaders()?.filter((ele) => ele?.show === true).map((item) => {
                                                    return (
                                                        <td
                                                            className={""}
                                                            style={{ textAlign: "start" }}
                                                        // style={{ textAlign: (ele?.label === "ProviderName" || ele?.label === "BuType" || ele?.label==="ChainName") ? "" : "center" }}
                                                        >
                                                            {" "}
                                                            {item?.label === "Insurer Name" ?
                                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                (<a
                                                                    className="text-highlighted text-decoration"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        //setScreen("second")
                                                                        setSearchFilter({
                                                                            ...searchFilter,
                                                                            clients: [{ clientId: ele?.clientId, clientName: ele?.clientName }],
                                                                            isInvoiceDetails: true,
                                                                            page: 1
                                                                        })
                                                                        //setClients([{clientId:ele?.clientId,clientName:ele?.clientName}])
                                                                    }}
                                                                >
                                                                    {ele[item?.col]}
                                                                </a>) : (<p>{item?.label === "Invoice Date" ? moment(ele[item?.col]).format("MM/DD/YYYY") : ele[item?.col]}</p>)}
                                                        </td>
                                                    );
                                                })}

                                            </tr>
                                        );
                                    })}
                                </tbody>
                            )}
                        </table>
                    </div>
                    {payoutReducer?.getTotalAppointmentPayout?.length === 0 && (
                        <p className="noRecordFound">No Record Found</p>
                    )}

                    <div className="d-flex justify-content-between">
                        <div className="pagination-row">
                            {globalReducer?.getTotalCount !== 0 && (
                                <CustomPagination
                                    totalCount={globalReducer?.getTotalCount}
                                    perPageData={searchFilter?.rows}
                                    searchFilter={searchFilter}
                                    setSearchFilter={setSearchFilter}
                                    apiCall={GetInvoiceDetailsNetwork}
                                    IsPayoutStatus={true}
                                />
                            )}
                        </div>
                    </div>

                    <Modal
                        isOpen={isOpenSetting}
                        // style={{maxWidth:"35%"}}
                        className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
                        overlayClassName="overlay-history-popup network-z-index"
                        ariaHideApp={false}
                    >
                        <AdditionalComponentHeader
                            setIsOpenSetting={setIsOpenSetting}
                            header={header2}
                            setHeader={setHeader2}
                            searchFilter={searchFilter}
                        />
                    </Modal>

                </div>
            </div>
        </div>
    );
};
